import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "children"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIForm from './UIForm';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UIFloatingForm = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const classes = classNames(className, 'private-floating-form');
  return /*#__PURE__*/_jsx(UIForm, Object.assign({
    className: classes
  }, props, {
    ref: ref,
    children: children
  }));
});
UIFloatingForm.propTypes = {
  children: PropTypes.node.isRequired
};
UIFloatingForm.displayName = 'UIFloatingForm';
export default UIFloatingForm;